module.exports = __webpack_public_path__ + "static/media/Photo10.e351b146.jpg";